import { ValueResponse } from '../../app/types';

interface ValueResponseDisplayProps {
  value: ValueResponse;
  fixedDigits: number;
};

ValueResponseDisplay.defaultProps = {
  fixedDigits: 2,
};

function ValueResponseDisplay(props: ValueResponseDisplayProps) {
  const { value, fixedDigits } = props;
  if (typeof value === "number") {
    return (<span>{value.toFixed(fixedDigits)}</span>);
  } else if (typeof value === "boolean") {
    return (<span>{value ? "True" : "False"}</span>);
  } else {
    return (<></>);
  }
}

export default ValueResponseDisplay;